import { initForethought } from './forethought';
import { initZendesk } from './zendesk';
import initSentry from './sentry';
import { initNewRelic } from './newrelic';
import { isNative, isWindows } from '../../../shared/utils/is';

export const setupLogging = async () => {
    if (isNative() && !isWindows()) {
        await initNewRelic();
    }

    initSentry();

    if ($f.active_user.is_logged_in()) {
        await initForethought();
    }

    if ($f.active_user.is_logged_in()) {
        await initZendesk();
    }
};
